import { InvestmentProductConfigurationFeature } from "@models/product/investment-product/entities/investmentProduct";
import { InvestmentFeatureHiddenInViewMode } from "@pages/suppliers/constants";
import { filter, isEqual } from "lodash";

export const GetAssetAllocationFeatureData = (data: InvestmentProductConfigurationFeature[]) => {
    return filter(data ?? [], (item) => {
        return !isEqual(item.name, InvestmentFeatureHiddenInViewMode.TARGET_EXISTS);
      });
}